import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import posthog from 'posthog-js';

if (environment.production) {
  enableProdMode();
}

posthog.init(environment.postHog, {
  api_host: 'https://app.posthog.com',
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false
});

bootstrapApplication(AppComponent, appConfig)
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
